import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {

    logoUrl:sessionStorage.getItem('logo'),

  },
  mutations: {

    setLogoUrl(state,url){

      state.logoUrl = url;
      sessionStorage.setItem('logo',url)

    }



  },
  actions: {

  }
})
